import {
  Box,
  Card,
  CardActionArea,
  Link,
  Theme,
  Typography,
} from "@mui/material";
import { makeStyles } from "helpers/StyleHelper";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

type NavCardProps = {
  title: string;
  url: string;
};

const useStyles = makeStyles((_: Theme) => ({
  cardActionArea: {
    height: "100%",
  },
}));

const NavCard = ({ title, url }: NavCardProps) => {
  const navigate = useNavigate();
  const styles = useStyles(useTheme());

  return (
    <Card style={{ height: "100%" }}>
      <CardActionArea
        onClick={() => navigate(url)}
        sx={styles.cardActionArea}
        data-cy={`${title}Button`}
      >
        <Link
          href={url}
          onClick={(e: any) => e.preventDefault()}
          sx={{ textDecoration: "none" }}
        >
          <Box my={4} mx={2} textAlign="center">
            <Typography variant="h5">{title}</Typography>
          </Box>
        </Link>
      </CardActionArea>
    </Card>
  );
};

export default NavCard;
